import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "video-container is-flex is-justify-content-center is-align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "is-flex is-flex-direction-column is-align-items-center"
}
const _hoisted_4 = { class: "subtitle" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 1,
  class: "main-div"
}
const _hoisted_7 = { class: "container" }
const _hoisted_8 = { class: "columns mt-4" }
const _hoisted_9 = { class: "column is-one-third-desktop is-offset-one-third-desktop" }
const _hoisted_10 = {
  key: 0,
  class: "message is-warning"
}
const _hoisted_11 = { class: "message-header" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { class: "field" }
const _hoisted_14 = { class: "label" }
const _hoisted_15 = { class: "has-text-grey-light is-size-7" }
const _hoisted_16 = { class: "is-flex is-justify-content-space-between is-align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_JitsiIframe = _resolveComponent("JitsiIframe")!

  return (_ctx.appointmentHash)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isChecking)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[3] || (_cache[3] = _createElementVNode("img", {
                  class: "loading-logo",
                  src: "https://i.imgur.com/BvpCaxv.png",
                  alt: "wisevet_live_logo"
                }, null, -1)),
                _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('AppointmentData.Connecting')), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "fa fa-spinner fa-spin fa-4x" }, null, -1))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_JitsiIframe, {
                  "appointment-hash": _ctx.appointmentHash,
                  "user-data": _ctx.userData,
                  language: _ctx.language
                }, null, 8, ["appointment-hash", "user-data", "language"])
              ]))
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[6] || (_cache[6] = _createElementVNode("img", {
                src: "https://i.imgur.com/uA3fRLZ.png",
                class: "image",
                alt: "logo"
              }, null, -1)),
              (_ctx.showWarning)
                ? (_openBlock(), _createElementBlock("article", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("p", null, [
                        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "fas fa-exclamation-triangle" }, null, -1)),
                        _createTextVNode(_toDisplayString(_ctx.$t('AppointmentData.Unavailable')), 1)
                      ])
                    ]),
                    _createElementVNode("div", {
                      class: "message-body",
                      innerHTML: _ctx.$t('AppointmentData.UnavailableExplanation')
                    }, null, 8, _hoisted_12)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("form", {
                onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.checkPIN && _ctx.checkPIN(...args)), ["prevent"])),
                class: "p-3"
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('AppointmentData.PIN')), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "number",
                    class: "input has-text-centered is-size-2",
                    placeholder: "xxxxxx",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pin) = $event)),
                    required: ""
                  }, null, 512), [
                    [_vModelText, _ctx.pin]
                  ]),
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('AppointmentData.PinInstructions')), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                  }, _toDisplayString(_ctx.$t('General.Back')), 1),
                  _createElementVNode("button", {
                    class: _normalizeClass(["button is-primary", {'is-loading':_ctx.isCheckingPIN}])
                  }, _toDisplayString(_ctx.$t('AppointmentData.Connect')), 3)
                ])
              ], 32)
            ])
          ])
        ])
      ]))
}